module.exports = __webpack_public_path__ + "static/auto_import_395x301-c80846d8d12cbf6ff429ac769b2865ea.webp";